import React from 'react';

export const LoanBalanceObject = [
  {
    param: 'balances',
    type: 'object',
    required: true,
    object: [
      {
        param: 'interest_paid',
        type: 'string',
        required: true,
        description: (
          <p>
            The interest paid on the balance of the loan. Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'interest_receivable',
        type: 'string',
        required: true,
        description: (
          <p>
            The interest earned, but not yet paid, on a loan. Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'principal_charged_off',
        type: 'string',
        required: true,
        description: (
          <p>
            The balance of the loan which has been charged off. Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'principal_holding',
        type: 'string',
        required: false,
        description: (
          <p>
            The balance of the loan which is in a <code>holding</code> state. Returns a <code>"0"</code> string when not
            applicable.
          </p>
        ),
      },
      {
        param: 'principal_outstanding',
        type: 'string',
        required: true,
        description: (
          <p>
            The balance of the loan which is outstanding. Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'principal_paid',
        type: 'string',
        required: true,
        description: (
          <p>
            The balance of the loan which has been paid. Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_interest_paid',
        type: 'string',
        required: false,
        description: (
          <p>
            Portion of the interest paid by the borrower that is kept by the lender or servicer. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_interest_receivable',
        type: 'string',
        required: false,
        description: (
          <p>
            Portion of the unpaid interest that the lender is owed and plans to keep once paid. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_principal_charged_off',
        type: 'string',
        required: false,
        description: (
          <p>
            Portion of the unpaid interest that the lender is owed and plans to keep once paid. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_principal_charged_off',
        type: 'string',
        required: false,
        description: (
          <p>
            Portion of the loan principal that the lender planned to keep, but has written off as a loss. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_principal_outstanding',
        type: 'string',
        required: false,
        description: (
          <p>
            Amount of the original loan (not interest) that the lender still expects to get back from the borrower.
            Returns a <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'retained_principal_paid',
        type: 'string',
        required: false,
        description: (
          <p>
            Portion of the loan principal that the borrower has repaid, and that the lender keeps. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
      {
        param: 'servicing_fee_payable',
        type: 'string',
        required: false,
        description: (
          <p>
            Amount of money the lender (or loan owner) owes to the loan servicer for managing the loan. Returns a{' '}
            <code>"0"</code> string when not applicable.
          </p>
        ),
      },
    ],
  },
];
